// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pa-0 > .v-expansion-panel__header {\n  padding: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
